<template>
  <main v-if="page">
    <section class="pt-25 lg:mt-0 h-pad py-12.5 lg:py-32.5 bg-dustrose">
      <RawHtml v-if="page.content" :html="page.content" class="max-w-250 mx-auto" v-reveal />
    </section>
  </main>
</template>

<script lang="ts">
import RawHtml from '@/components/helpers/RawHtml.vue'
import PageHeader from '@/components/sections/header/PageHeader.vue'
import { usePageContent } from '@/composables/usePageContent.ts'

export default {
  name: 'PrivacyPage',
  components: { RawHtml, PageHeader },
  setup() {
    const { page } = usePageContent('privacy')

    return { page }
  },
}
</script>
